var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-collapsible",
      class: {
        "cw-collapsible-open": _vm.isOpen,
      },
    },
    [
      _c(
        "a",
        {
          attrs: {
            href: "#",
            "aria-expanded": _vm.isOpen,
          },
          on: {
            click: function click($event) {
              $event.preventDefault()
              _vm.isOpen = !_vm.isOpen
            },
          },
        },
        [
          _c(
            "header",
            {
              staticClass: "cw-collapsible-title",
              class: {
                "cw-collapsible-open": _vm.isOpen,
              },
            },
            [
              _vm.icon
                ? _c("studip-icon", {
                    attrs: {
                      shape: _vm.icon,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._t(
                "title",
                function () {
                  return [_vm._v(_vm._s(_vm.title))]
                },
                {
                  isOpen: _vm.isOpen,
                }
              ),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.isOpen
        ? _c(
            "div",
            {
              staticClass: "cw-collapsible-content",
              class: {
                "cw-collapsible-content-open": _vm.isOpen,
              },
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }